// @ts-check
import { Circle, Path, Svg } from '@react-pdf/renderer';
import React from 'react';

/**
 * An award icon.
 *
 * @param {{  color: string; size: string | number; style?: import('@react-pdf/types').Style }} props
 */
export default function ShoppingCartIcon({ color, size, style }) {
  return (
    <Svg viewBox="0 0 24 24" style={[{ width: size }, style]}>
      <Circle stroke={color} strokeWidth={2} cx="9" cy="21" r="1" />
      <Circle stroke={color} strokeWidth={2} cx="20" cy="21" r="1" />
      <Path
        stroke={color}
        strokeWidth={2}
        d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"
      />
    </Svg>
  );
}
